module.exports = __webpack_public_path__ + "img/flash.c6c62cd.png";